var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveredIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98014 0.333344C3.30014 0.333344 0.313477 3.32001 0.313477 7.00001C0.313477 10.68 3.30014 13.6667 6.98014 13.6667C10.6601 13.6667 13.6468 10.68 13.6468 7.00001C13.6468 3.32001 10.6668 0.333344 6.98014 0.333344ZM7.00014 9.82001C5.44014 9.82001 4.18014 8.56001 4.18014 7.00001C4.18014 5.44001 5.44014 4.18001 7.00014 4.18001C8.56014 4.18001 9.82014 5.44001 9.82014 7.00001C9.82014 8.56001 8.56014 9.82001 7.00014 9.82001Z",
    fill: "#D5D7EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveredIcon);
export default __webpack_public_path__ + "static/media/delivered-icon.74602ba91591771009816b3e31ca959f.svg";
export { ForwardRef as ReactComponent };